import React from 'react';
import { faCircleInfo, faFillDrip } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';
import CalendarSizeFields from 'components/actionBar/ActionBarCalendar/components/CalendarSizeFields';
import CustomSelect from 'components/actionBar/components/CustomSelect';
import ToolBarColorPicker from 'components/actionBar/components/ToolbarColorPicker';
import Switch from 'components/common/Switch';
import c from '../CalendarGrid.module.scss';
import SettingsSection from '../SettingsSection';

const calendarTypeOptions = [
  { value: 1, label: 'Month grid' },
  { value: 2, label: 'Two-row strip' },
];

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.calendar Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @returns {React.ReactElement}
 */
const GeneralSettingsSection = ({ calendar, onChange }) => {
  const showDebugGuides = calendar.showDebugGuides === true;

  return (
    <SettingsSection title="General">
      <div className={c.generalField}>
        <div className={c.fieldLabel}>Calendar type</div>
        <CustomSelect
          options={calendarTypeOptions}
          value={calendar.calendarType || 1}
          onChange={(calendarType) => onChange({ calendarType })}
          classNamePrefix="calendar-type-select"
        />
      </div>
      <div className={c.generalField}>
        <div className={c.fieldLabel}>Background colour</div>
        <div className={c.colourControl}>
          <ToolBarColorPicker
            initialValue={calendar.backgroundColor}
            onChange={(backgroundColor) => onChange({ backgroundColor })}
            icon={faFillDrip}
            disableAlpha={false}
            disableIconColorMatching
            alignPickerLeft
          />
        </div>
      </div>
      <CalendarSizeFields
        shape={calendar}
        onChange={onChange}
        fieldClassName={c.field}
        paddingLabel="Calendar padding"
        showDayMargin={false}
      />
      <div className={c.generalField}>
        <Switch
          id="calendar-other-month-days"
          checked={calendar.showOtherMonthDays !== false}
          onChange={() => onChange({ showOtherMonthDays: calendar.showOtherMonthDays === false })}
          label="Show previous/next month days"
        />
      </div>
      <div className={c.generalField}>
        <div className={c.debugSettingRow}>
          <Switch
            id="calendar-debug-guides"
            className={c.debugSwitch}
            checked={showDebugGuides}
            onChange={() => onChange({ showDebugGuides: !showDebugGuides })}
            label="Show debug guides"
          />
          <button
            type="button"
            className={c.infoButton}
            aria-label="About debug guides"
            data-for="calendarDebugGuidesTooltip"
            data-tip="Shows the dashed calendar boundary for debugging in admin mode. This guide is not part of the final design."
          >
            <FontAwesomeIcon.Memo icon={faCircleInfo} />
          </button>
          <ReactTooltip id="calendarDebugGuidesTooltip" place="right" type="dark" effect="solid" />
        </div>
      </div>
    </SettingsSection>
  );
};

export default GeneralSettingsSection;
